import { Delete, X, Plus, Minus, Percent } from "lucide-react";

const KEYS = [
  ["7", "8", "9"],
  ["4", "5", "6"],
  ["1", "2", "3"],
  ["0", "00", "000"],
];

export default function Keypad({ onKey, onAdd, onSubtract, onTimes, onBackspace, onClear }) {
  const btn =
    "h-16 rounded-[4px] font-black text-2xl tabular-nums transition-all active:scale-[0.97] select-none";

  return (
    <div className="grid grid-cols-4 gap-2" data-testid="pos-keypad">
      <div className="col-span-3 grid grid-cols-3 gap-2">
        {KEYS.flat().map((k) => (
          <button
            key={k}
            type="button"
            data-testid={`key-${k}`}
            onClick={() => onKey(k)}
            className={`${btn} bg-white text-slate-900 border-2 border-slate-200 hover:border-slate-900 shadow-sm`}
          >
            {k}
          </button>
        ))}
      </div>

      <div className="grid grid-rows-4 gap-2">
        <button
          type="button"
          data-testid="key-backspace"
          onClick={onBackspace}
          className={`${btn} bg-slate-200 text-slate-800 hover:bg-slate-300 flex items-center justify-center`}
          aria-label="Backspace"
        >
          <Delete size={22} strokeWidth={2.6} />
        </button>
        <button
          type="button"
          data-testid="key-times"
          onClick={onTimes}
          className={`${btn} bg-slate-900 text-white hover:bg-slate-800 flex items-center justify-center`}
          aria-label="Multiply by quantity"
        >
          <X size={22} strokeWidth={3} />
        </button>
        <button
          type="button"
          data-testid="key-minus"
          onClick={onSubtract}
          className={`${btn} bg-[#b91c1c] text-white hover:bg-[#991b1b] flex items-center justify-center`}
          aria-label="Subtract amount"
        >
          <Minus size={24} strokeWidth={3} />
        </button>
        <button
          type="button"
          data-testid="key-plus"
          onClick={onAdd}
          className={`${btn} bg-[#15803d] text-white hover:bg-[#166534] flex items-center justify-center`}
          aria-label="Add amount"
        >
          <Plus size={26} strokeWidth={3} />
        </button>
      </div>

      <button
        type="button"
        data-testid="key-clear"
        onClick={onClear}
        className="col-span-4 h-12 rounded-[4px] bg-white border-2 border-slate-300 text-slate-700 font-bold uppercase tracking-[0.16em] text-xs hover:border-[#b91c1c] hover:text-[#b91c1c] transition-colors flex items-center justify-center gap-2"
      >
        <Percent size={13} className="opacity-0" />
        Clear all
      </button>
    </div>
  );
}
